import { DownOutlined } from '@ant-design/icons'
import { isUltimate } from '@merchant-backend/util'
import { isImageMogr2 } from '@util'
import { InputNumber } from 'hljd'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import { HALL_TYPE_ID, PACKAGE_TYPE_ID } from '../constant'
import Style from './style.module.less'

@inject('store')
@observer
export default class extends Component {
  state = {
    open: false
  }

  changeOpen = () => {
    this.setState({
      open: !this.state.open
    })
  }

  render() {
    const { typeId, list = [], overflowCount } = this.props
    const { open } = this.state
    let showMore = false
    if (list.length > overflowCount) {
      showMore = true
    }
    return (
      <div className={Style.list}>
        {list.map((item, index) => {
          if (index >= overflowCount && !open) {
            return null
          }
          const refs = React.createRef()
          return (
            <Item
              refs={refs}
              key={index}
              config={{ typeId, index, data: item }}
            />
          )
        })}
        {showMore && (
          <p className={`${Style.item} ${Style.more}`}>
            <span onClick={this.changeOpen}>
              {open ? '收起更多' : '展开更多'}
              <DownOutlined className={open ? Style.open : ''} />
            </span>
          </p>
        )}
      </div>
    )
  }
}

const Item = inject('store')(
  observer(
    ({
      store: {
        deleteRecommend,
        setRecommendIntroduce,
        entityIntroduced,
        intentPriceChange,
        intentPriceFocus,
        intentPriceBlur,
        liveStatus
      },
      refs,
      config: { typeId, index, data: item }
    }) => {
      const coverPath = item.coverPath || item.coverUrl
      const title = item.title || item.name
      // intentType: 1运营设置 2商家设置意向金
      // liveStatus: 1进行中 2未开始
      switch (typeId) {
        case PACKAGE_TYPE_ID:
          /*可以编辑意向金: 直播未开始 || 直播进行中并且是商家设置的意向金 || 直播进行中并且意向金为空 */
          const canEdit =
            isUltimate() &&
            (liveStatus == 2 ||
              (liveStatus == 1 && item.intentType == 2) ||
              (liveStatus == 1 && Object.is(item.intentPrice, undefined)))
          return (
            <div className={Style.item}>
              <div className={Style.content} style={{ height: 119 }}>
                <div className={Style.left}>
                  {item.id == entityIntroduced ? (
                    <div className={`${Style.status} ${Style.on}`}>介绍中</div>
                  ) : (
                    <div className={Style.status}>{index + 1}</div>
                  )}
                  <img src={isImageMogr2(coverPath, 160, 90)} />
                </div>
                <div className={Style.right}>
                  <p className={Style.name}>{title}</p>
                  <div className={Style.bottom} style={{ display: 'block' }}>
                    <div className={Style.bottomTop}>
                      <div className={Style.bottomLeft}>
                        ¥{item.actualPrice}
                        {item.marketPrice && <span>¥{item.marketPrice}</span>}
                      </div>
                    </div>
                    <div
                      className={Style.bottomRight}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <div>
                        {canEdit ? (
                          <>
                            <label htmlFor={'intentPrice' + index}>
                              意向金：
                            </label>
                            <InputNumber
                              id={'intentPrice' + index}
                              min={0}
                              step={0.1}
                              precision={1}
                              ref={refs}
                              size="small"
                              style={{ minWidth: 60 }}
                              defaultValue={item.intentPrice}
                              formatter={value =>
                                `¥ ${value}`.replace(
                                  /\B(?=(\d{3})+(?!\d))/g,
                                  ','
                                )
                              }
                              parser={value => value.replace(/¥\s?|(,*)/g, '')}
                              onChange={intentPriceChange}
                              onFocus={intentPriceFocus(item.intentPrice)}
                              onBlur={intentPriceBlur(
                                refs,
                                item.id,
                                item.actualPrice,
                                item.intentPrice
                              )}
                            />
                          </>
                        ) : (
                          !!item.intentPrice && (
                            <>
                              <label>意向金：</label>
                              <span>¥ {item.intentPrice}</span>
                            </>
                          )
                        )}
                      </div>
                      <div className={Style.operation}>
                        <span onClick={deleteRecommend(typeId, item.id, index)}>
                          删除
                        </span>
                        {item.id == entityIntroduced ? (
                          <span className={Style.disabled}>设为介绍中</span>
                        ) : (
                          <span onClick={setRecommendIntroduce(item.id)}>
                            设为介绍中
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        case HALL_TYPE_ID:
          return (
            <div className={Style.item}>
              <div className={Style.content}>
                <div className={Style.left}>
                  {item.id == entityIntroduced ? (
                    <div className={`${Style.status} ${Style.on}`}>介绍中</div>
                  ) : (
                    <div className={Style.status}>{index + 1}</div>
                  )}
                  <img src={isImageMogr2(coverPath, 160, 90)} />
                </div>
                <div className={Style.right}>
                  <p className={Style.name}>{title}</p>
                  <div className={Style.bottom}>
                    <div className={Style.bottomLeft}>
                      <p style={{ lineHeight: '20px', margin: '5px 0' }}>
                        {item.bestTableNum ? (
                          <span className={Style['color-FF801A']}>
                            {item.maxTableNum
                              ? `${item.bestTableNum}-${item.maxTableNum}桌`
                              : item.bestTableNum + '桌'}
                          </span>
                        ) : null}
                        {item.pillar ? (
                          <span className={Style['color-FF801A']}>
                            {item.pillar + '立柱'}
                          </span>
                        ) : null}
                        <span>{`${item.shape ? item.shape : ''}`}</span>
                      </p>
                      <p>
                        {item.height ? (
                          <span className={Style['color-999']}>
                            {'层高' + item.height + 'm'}
                          </span>
                        ) : null}
                        {item.area ? (
                          <span
                            className={Style['color-999']}
                            dangerouslySetInnerHTML={{
                              __html: `面积${item.area}m<sup>2</sup>`
                            }}
                          />
                        ) : null}
                      </p>
                    </div>
                    <div className={Style.bottomRight}>
                      <div className={Style.operation}>
                        <span onClick={deleteRecommend(typeId, item.id, index)}>
                          删除
                        </span>
                        {item.id == entityIntroduced ? (
                          <span className={Style.disabled}>设为介绍中</span>
                        ) : (
                          <span onClick={setRecommendIntroduce(item.id)}>
                            设为介绍中
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        default:
          return (
            <div className={Style.item}>
              <div className={Style.content}>
                <div className={Style.left}>
                  <div className={Style.status}>{index + 1}</div>
                  <img src={isImageMogr2(coverPath, 160, 90)} />
                </div>
                <div className={Style.right}>
                  <p className={Style.name}>{title}</p>
                  <div className={Style.bottom}>
                    <div className={Style.bottomLeft}>
                      发布时间：{item.publishedTime}
                    </div>
                    <div className={Style.bottomRight}>
                      <div className={Style.operation}>
                        <span onClick={deleteRecommend(typeId, item.id, index)}>
                          删除
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
      }
    }
  )
)
